import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import Confirm from 'components/Confirm';
import Dot from 'components/Dot';
import Message from 'components/Message';
import { ICONS } from 'constants/icons';
import { bem } from 'helpers/class-name';

import {
  ITEM_AVAILABILITY_STATUS,
  ITEM_AVAILABILITY_STATUS_MAPPING,
  ITEM_AVAILABILITY_STATUS_OPTIONS,
} from '../Items/SkuItems.constants';
import { skuItemAvailabilityStatusMessages } from '../Items/SkuItems.messages';
import messages from './SkuAvailabilityModal.messages';

import './SkuAvailabilityModal.scss';

export const SKU_AVAILABILITY_MODAL_NAME = 'SkuAvailabilityModal';

const { block, element } = bem('sku-availability-modal');

const StatusMarker = ({ status }) => {
  if (status === ITEM_AVAILABILITY_STATUS.UNAVAILABLE_INDEFINITELY) {
    return <Isvg className={element('status-marker', { icon: true })} src={ICONS.noSymbol} />;
  }
  return <Dot className={element('status-marker')} color={ITEM_AVAILABILITY_STATUS_MAPPING[status]?.color} largeSize />;
};

StatusMarker.propTypes = {
  status: PropTypes.oneOf(ITEM_AVAILABILITY_STATUS_OPTIONS).isRequired,
};

const SkuAvailabilityModal = ({ itemName, onConfirm, onCancel }) => {
  const [selectedStatus, setSelectedStatus] = useState(ITEM_AVAILABILITY_STATUS.AVAILABLE);

  const isUnavailableToday = selectedStatus === ITEM_AVAILABILITY_STATUS.UNAVAILABLE_TODAY;

  return (
    <Confirm
      className={block()}
      title={itemName}
      hasCloseButton
      onCancel={onCancel}
      cancelNode={<Message message={messages.cancel} />}
      acceptNode={<Message message={messages.continue} />}
      onConfirm={() => onConfirm(selectedStatus)}
      size="complex">
      {({ title, buttons }) => (
        <>
          {title}
          <div className={element('options')}>
            {ITEM_AVAILABILITY_STATUS_OPTIONS.map((status, idx) => {
              const isSelected = selectedStatus === status;
              const statusMessage =
                skuItemAvailabilityStatusMessages[ITEM_AVAILABILITY_STATUS_MAPPING[status]?.message];
              const showDescription = isUnavailableToday && status === ITEM_AVAILABILITY_STATUS.UNAVAILABLE_TODAY;

              return (
                <React.Fragment key={status}>
                  {idx > 0 && <div className={element('divider')} />}
                  <label className={element('option', { selected: isSelected })}>
                    <div className={element('option-left')}>
                      <StatusMarker status={status} />
                      <span className={element('option-label')}>
                        <Message message={statusMessage} />
                      </span>
                    </div>
                    <input
                      type="radio"
                      className={element('radio')}
                      name="sku-availability-status"
                      value={status}
                      checked={isSelected}
                      onChange={() => setSelectedStatus(status)}
                    />
                  </label>
                  {showDescription && (
                    <p className={element('option-description')}>
                      <Message message={messages.unavailableTodayDescription} />
                    </p>
                  )}
                </React.Fragment>
              );
            })}
          </div>
          {buttons}
        </>
      )}
    </Confirm>
  );
};

SkuAvailabilityModal.propTypes = {
  itemName: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
};

export default SkuAvailabilityModal;
